import { MasterIdConflict } from '@modules/duplicateResolution/models/MasterIdConflict';

import { createAdminApi, getApiBaseUrl } from '../shared/utils';

const api = createAdminApi(getApiBaseUrl('masterId'), { 'x-api-version': '1.0' });

export const replaceMasterId = (currentMasterId: string, newMasterId: string) =>
  api.post(currentMasterId, { resolvedMasterId: newMasterId });

export const movePlaybackOption = (
  platformTitleId: string,
  currentMasterId: string,
  newMasterId: string
) =>
  api.post(`/${currentMasterId}/playbackOption/${platformTitleId}`, {
    resolvedMasterId: newMasterId,
  });

export const splitPlaybackOption = (platformTitleId: string, currentMasterId: string) =>
  api.post(`/${currentMasterId}/playbackOption/${platformTitleId}`, { resolvedMasterId: '' });

export const fetchPendingMasterIdConflicts = () => api.get<MasterIdConflict[]>('conflicts/pending');

/**
 * @param baseMasterId Master ID of the base title. Values in this title will have priority.
 * @param masterIdToMerge Master ID of the title to be merged into the base title.
 */
export const resolveMasterIdConflict = (baseMasterId: string, masterIdToMerge: string) =>
  api.post(masterIdToMerge, { resolvedMasterId: baseMasterId });

export const deleteMasterIdConflict = (masterId: string) =>
  api.delete(`conflicts/pending/${masterId}`);

/**
 * Merges all possible duplicates into the base title
 * @param masterId The Master ID of the base title that all other titles will be merged into
 */
export const collapseMasterIdConflict = (masterId: string) =>
  api.post(`conflicts/pending/${masterId}/collapse`, undefined, {});
